module.exports = __webpack_public_path__ + "img/ic_login_consumer.6c7d8098.svg";